export const getAsyncActionTypes = (prefix, actionName) =>
  ['REQUEST', 'SUCCESS', 'FAILURE'].reduce(
    (obj, type) => ({
      ...obj,
      [type]: `${prefix}/${actionName}_${type}`
    }),
    {}
  );
